// value for updating call record,
//there is only one value that is used atm 2 is the value for SIP for relay, H323 is no longer used
export const sipDeafProtocol = 2;
